/**
 * @license lucide-react v0.570.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const __iconNode = [
  ["path", { d: "M12 6h4a2 2 0 0 1 2 2v7", key: "18ej7s" }],
  ["path", { d: "M6 12v9", key: "9e33v1" }],
  ["path", { d: "M9 3 3 9", key: "ahyygn" }],
  ["path", { d: "M9 9 3 3", key: "v551iv" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }]
];
const GitMergeConflict = createLucideIcon("git-merge-conflict", __iconNode);

export { __iconNode, GitMergeConflict as default };
//# sourceMappingURL=git-merge-conflict.js.map
